<div>
	<ul>
		<li *ngFor="let preset of filterConfig?.presets">
			<label [ngClass]="{'active': (currentFilter == preset.value)}" *ngIf="preset.value !== 'all'">
				<bb-check [checked]="storedItems.indexOf(preset.id || preset.value) > -1" (onChanged)="optionChecked(preset, $event)"></bb-check>
				<span class="text" >{{ preset.label }}</span>
					<i *ngIf="preset.id" (click)="deletePreset(preset)" class="button fa fa-trash"></i>
			</label>
		</li>
	</ul>
	<ng-container *ngIf="allowCustomPreset && filterSet && filterSet?.length > 0">
		<div class="save-preset" (click)="enterPreset()" [ngStyle]="{'display' : editMode ? 'none' : 'block' }">
			{{ 'SAVE_PRESET' | translate }}
		</div>
		<bb-form-element [form]="form" [ngStyle]="{'display' : editMode ? 'block' : 'none' }">
			<input 
				[(ngModel)]="customPreset" 
				(change)="onInputChanged(customPreset)" 
				type="text" 
				#newPresetInput 
				class="save-preset-input" 
				[ngStyle]="{'display' : editMode ? 'block' : 'none' }"
				placeholder="{{ 'ENTER_PRESET_NAME' | translate }}">
		</bb-form-element>
	</ng-container>
</div>